// Standalone shared constants. RESET_PASSWORD_PATH lives here (rather than only
// as an entry in URLBuilder's URL map) because the dashboard's pre-React inline
// reset-password sanitizer needs this path at build time and cannot load the
// full @termly-web/common barrel (it pulls in SCSS-importing components).
export const RESET_PASSWORD_PATH = '/user/reset-password'

// The flow token exchange lives here for the same reason: the dashboard's
// standalone flow token page calls the same endpoint (in the top-level context,
// where the dashboard calls it in the iframe one), and it is built from a
// template that cannot load the barrel either. Relative to the site root.
export const FLOW_TOKEN_EXCHANGE_PATH = 'api/v1/enterprise/auth'

// Longer than the client's usual limit, because the server can be slow to
// answer when the identity provider is, and an exchange abandoned before it
// answers has still spent the token. Waiting longer costs a slow sign-in;
// giving up early costs the session.
export const FLOW_TOKEN_EXCHANGE_TIMEOUT_MS = 30_000
